import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Small "Verified Organization" chip. Rendered next to an org's name on
 * job listings, public profiles, and inside the org convert flow.
 * Verification is granted when the user's login email domain matches the
 * `org_domain` they claim at conversion / signup.
 */
export default function VerifiedOrgBadge({ size = "sm", className = "" }) {
    const px = size === "lg" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full font-display font-bold tracking-wide ${px} ${className}`}
            style={{ background: "#DBF3E9", color: "#136A4A" }}
            data-testid="verified-org-badge"
            title="Domain-verified organization"
        >
            <BadgeCheck className="w-3 h-3" />
            Verified Org
        </span>
    );
}
